import { createFileRoute } from '@tanstack/react-router';

import { SecretaryConnectPage } from '@/features/secretary/SecretaryPages.js';

export const Route = createFileRoute('/secretary/connect/$requestId')({
  component: ConnectRoute,
});

function ConnectRoute() {
  const { requestId } = Route.useParams();
  return <SecretaryConnectPage requestId={requestId} />;
}
